/* Huta · Packs por cantidad ("¿Cuántas te llevas?").
   Markup: blocks/huta-packs-cantidad.liquid · estilos: assets/huta-custom.css

   Solo toca estado visual y la cantidad del formulario: escribe sobre el input
   `quantity` que ya existe en el bloque de compra, así al enviar se añade una
   línea con 1, 2 o 3 unidades y el carrito no duplica nada.

   El descuento NO se aplica aquí: lo aplica el descuento automático de Shopify
   en el carrito. Lo de aquí es lo que se enseña; tiene que coincidir. */
(function () {
  'use strict';

  if (window.__hutaPacksCargado) return;
  window.__hutaPacksCargado = true;

  /* ---- dinero -----------------------------------------------------------
     Reproduce el formato de la tienda (shop.money_format) para que los tres
     cuadrados se lean igual que el precio de arriba. */
  function separadores(cents, decimales, milesSep, decSep) {
    var negativo = cents < 0;
    var n = Math.abs(Math.round(cents)) / 100;
    var partes = n.toFixed(decimales).split('.');
    var entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, milesSep);
    var salida = decimales > 0 ? entero + decSep + partes[1] : entero;
    return (negativo ? '-' : '') + salida;
  }

  function money(cents, formato) {
    var f = formato || '{{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, clave) {
      switch (clave) {
        case 'amount':
          return separadores(cents, 2, ',', '.');
        case 'amount_no_decimals':
          return separadores(cents, 0, ',', '.');
        case 'amount_with_comma_separator':
          return separadores(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return separadores(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return separadores(cents, 2, "'", '.');
        default:
          return separadores(cents, 2, ',', '.');
      }
    });
  }

  /* ---- ayudas ----------------------------------------------------------- */
  function seccionDe(nodo) {
    return nodo.closest('.shopify-section, [id^="shopify-section"]') || document;
  }

  function formularioDe(raiz) {
    var seccion = seccionDe(raiz);
    return seccion.querySelector('form[data-type="add-to-cart-form"]');
  }

  function inputCantidad(raiz) {
    var form = formularioDe(raiz);
    return form ? form.querySelector('input[name="quantity"]') : null;
  }

  function botonAnadir(raiz) {
    var form = formularioDe(raiz);
    return form ? form.querySelector('.add-to-cart-text__content') : null;
  }

  function variantePorId(raiz) {
    var form = formularioDe(raiz);
    var input = form ? form.querySelector('input[name="id"]') : null;
    return input ? String(input.value) : null;
  }

  /* ---- un bloque -------------------------------------------------------- */
  function iniciar(raiz) {
    if (raiz.__hutaPacks) return;
    raiz.__hutaPacks = true;

    var umbral = parseInt(raiz.dataset.umbral, 10) || 0;
    var formato = raiz.dataset.formato || '{{amount}}';
    var descuentos = (raiz.dataset.descuentos || '0,0,0').split(',').map(function (d) {
      return parseFloat(d) || 0;
    });
    var frases = (raiz.dataset.frases || '||').split('|');
    var txtUnidad = raiz.dataset.textoUnidad || 'Precio unidad';
    var txtAhorro = raiz.dataset.textoAhorro || 'Ahorras';

    var precios = {};
    var json = raiz.querySelector('[data-huta-packs-precios]');
    if (json) {
      try {
        precios = JSON.parse(json.textContent);
      } catch (e) {
        precios = {};
      }
    }

    var cuadrados = Array.prototype.slice.call(raiz.querySelectorAll('[data-huta-pack]'));
    var nota = raiz.querySelector('[data-huta-packs-note]');
    var unidad = parseInt(raiz.dataset.unidad, 10) || 0;
    var elegido = 1;
    var etiquetaBoton = null;

    function totalDe(cantidad) {
      var dto = descuentos[cantidad - 1] || 0;
      return Math.round((unidad * cantidad * (100 - dto)) / 100);
    }

    /* El importe del botón se repinta siempre desde la etiqueta original: si la
       sección se vuelve a renderizar al cambiar de variante, el botón es otro y
       hay que volver a leerla. */
    function pintarBoton() {
      var destino = botonAnadir(raiz);
      if (!destino) return;
      if (etiquetaBoton === null || !destino.dataset.hutaPacksBase) {
        etiquetaBoton = destino.textContent.split('·')[0].trim();
        destino.dataset.hutaPacksBase = etiquetaBoton;
      }
      destino.textContent = destino.dataset.hutaPacksBase + ' · ' + money(totalDe(elegido), formato);
    }

    function pintarCuadrados() {
      var input = inputCantidad(raiz);
      var maximo = input && input.max ? parseInt(input.max, 10) : null;

      cuadrados.forEach(function (cuadrado) {
        var cantidad = parseInt(cuadrado.dataset.cantidad, 10);
        var dto = descuentos[cantidad - 1] || 0;
        var total = totalDe(cantidad);
        var bruto = unidad * cantidad;

        var elTotal = cuadrado.querySelector('[data-pack-total]');
        var elAhorro = cuadrado.querySelector('[data-pack-save]');
        var elSub = cuadrado.querySelector('[data-pack-sub]');
        var elEnvio = cuadrado.querySelector('[data-pack-ship]');

        if (elTotal) elTotal.textContent = money(total, formato);
        if (elAhorro) elAhorro.textContent = dto > 0 ? txtAhorro + ' ' + dto + '%' : txtUnidad;

        if (elSub) {
          if (dto > 0) {
            elSub.innerHTML = '';
            var was = document.createElement('s');
            was.className = 'huta-pack__was';
            was.textContent = money(bruto, formato);
            var each = document.createElement('span');
            each.className = 'huta-pack__each';
            each.textContent = money(Math.round(total / cantidad), formato) + ' c/u';
            elSub.appendChild(was);
            elSub.appendChild(each);
          } else {
            elSub.innerHTML = '&nbsp;';
          }
        }

        if (elEnvio) elEnvio.hidden = !(umbral > 0 && total >= umbral);

        /* Si el inventario no da para el pack, el cuadrado se apaga: mejor eso
           que un botón que no envía por la validación del input. */
        var fueraDeStock = maximo !== null && !isNaN(maximo) && cantidad > maximo;
        cuadrado.disabled = fueraDeStock;
        cuadrado.classList.toggle('is-disabled', fueraDeStock);

        var activo = cantidad === elegido;
        cuadrado.classList.toggle('is-selected', activo);
        cuadrado.setAttribute('aria-pressed', activo ? 'true' : 'false');
      });

      if (nota) nota.textContent = frases[elegido - 1] || '';
      if (input) input.value = String(elegido);
      pintarBoton();
    }

    function elegir(cantidad) {
      elegido = cantidad;
      pintarCuadrados();
    }

    cuadrados.forEach(function (cuadrado) {
      cuadrado.addEventListener('click', function () {
        if (cuadrado.disabled) return;
        elegir(parseInt(cuadrado.dataset.cantidad, 10));
      });
    });

    /* Al cambiar de variante se recalculan los tres precios sin recargar. */
    function alCambiarVariante(evento) {
      var id = evento && evento.detail && evento.detail.resource ? evento.detail.resource.id : null;
      if (!id) id = variantePorId(raiz);
      var nuevo = precios[String(id)];
      if (typeof nuevo === 'number') unidad = nuevo;
      /* El botón lo repinta el tema al re-renderizar: esperamos un tick. */
      requestAnimationFrame(pintarCuadrados);
    }

    seccionDe(raiz).addEventListener('variant:update', alCambiarVariante);
    document.addEventListener('variant:update', alCambiarVariante);

    pintarCuadrados();
  }

  function arrancar() {
    document.querySelectorAll('[data-huta-packs]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  /* En el editor de temas el bloque se reinserta al tocar sus ajustes. */
  document.addEventListener('shopify:section:load', arrancar);
  document.addEventListener('shopify:block:select', arrancar);
})();
